import { render, staticRenderFns } from "./SearchPage.vue?vue&type=template&id=a7371b2c&"
import script from "./SearchPage.vue?vue&type=script&setup=true&lang=js&"
export * from "./SearchPage.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports